import type { ProductVariant } from '@/entities/product';

import type { ProductDescriptionMap, ProductParsedDescription } from '../types';
import { parseProductDescription } from './productDescriptionParser';

export const getProductDescriptionMap = (variants?: Record<string, ProductVariant>): ProductDescriptionMap => {
    const productDescriptionMap = new Map<number, ProductParsedDescription | null>();

    for (const variant of Object.values(variants ?? {})) {
        const sku = parseInt(variant?.sku ?? '', 10);
        if (Number.isNaN(sku)) continue;
        const description = variant?.description ? parseProductDescription(variant.description) : null;
        productDescriptionMap.set(sku, description);
    }

    return productDescriptionMap;
};
